import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function UnAuhtorized() {
 // const user = useContext(UserContext)
 const history = useHistory();

 history.push("/login");
  return (
    <div >
       <h2>UnAuthorized</h2>
    </div>
      
     
  
      
  );
}